<template>
  <ul class="lists check-item">
    <!-- 01 greeting -->
    <li class="list-item">
      <div class="item greeting" :class="{ checked: checkedItems[1] }" data-id="1" @click="toggleCampaignItemCheck(1)">
        <div class="item-icon">
          <div class="check-badge" />
        </div>
        <div class="text">
          <div class="info">
            <span class="theme color">{{ $t('인사') }}</span>
            <span class="desc" v-html="removeTag($t('평화를여는첫마디'))" />
          </div>
          <div class="title">
            {{ removeTag($t('안녕하세요')) }}
          </div>
        </div>
      </div>
    </li>
    <!-- 02 thanks -->
    <li class="list-item">
      <div class="item thanks" :class="{ checked: checkedItems[2] }" data-id="2" @click="toggleCampaignItemCheck(2)">
        <div class="item-icon">
          <div class="check-badge" />
        </div>
        <div class="text">
          <div class="info">
            <span class="theme color">{{ $t('감사') }}</span>
            <span class="desc" v-html="removeTag($t('작은수고와배려에도고마움을표현해보세요'))" />
          </div>
          <div class="title">
            {{ removeTag($t('고마워요덕분이에요애쓰셨어요')) }}
          </div>
        </div>
      </div>
    </li>
    <!-- 03 apology -->
    <li class="list-item">
      <div class="item apology" :class="{ checked: checkedItems[3] }" data-id="3" @click="toggleCampaignItemCheck(3)">
        <div class="item-icon">
          <div class="check-badge" />
        </div>
        <div class="text">
          <div class="info">
            <span class="theme color">{{ $t('사과') }}</span>
            <span class="desc" v-html="removeTag($t('마음을녹이는한마디상대를먼저이해해보세요'))" />
          </div>
          <div class="title">
            {{ removeTag($t('내가미안해요힘들었죠')) }}
          </div>
        </div>
      </div>
    </li>
    <!-- 04 tolerance -->
    <li class="list-item">
      <div class="item tolerance" :class="{ checked: checkedItems[4] }" data-id="4" @click="toggleCampaignItemCheck(4)">
        <div class="item-icon">
          <div class="check-badge" />
        </div>
        <div class="text">
          <div class="info">
            <span class="theme color">{{ $t('포용') }}</span>
            <span class="desc" v-html="removeTag($t('허물을감싸주는한마디'))" />
          </div>
          <div class="title">
            {{ removeTag($t('괜찮아요그럴수있어요')) }}
          </div>
        </div>
      </div>
    </li>
    <!-- 05 yield -->
    <li class="list-item">
      <div class="item yield" :class="{ checked: checkedItems[5] }" data-id="5" @click="toggleCampaignItemCheck(5)">
        <div class="item-icon">
          <div class="check-badge" />
        </div>
        <div class="text">
          <div class="info">
            <span class="theme color">{{ $t('양보') }}</span>
            <span class="desc" v-html="removeTag($t('조급할수록여유를갖고양보하면어떨까요'))" />
          </div>
          <div class="title">
            {{ removeTag($t('먼저하세요')) }}
          </div>
        </div>
      </div>
    </li>
    <!-- 06 esteem -->
    <li class="list-item">
      <div class="item esteem" :class="{ checked: checkedItems[6] }" data-id="6" @click="toggleCampaignItemCheck(6)">
        <div class="item-icon">
          <div class="check-badge" />
        </div>
        <div class="text">
          <div class="info">
            <span class="theme color">{{ $t('존중') }}</span>
            <span class="desc" v-html="removeTag($t('의견이다를때상대의말에더귀기울여주세요'))" />
          </div>
          <div class="title">
            {{ removeTag($t('당신의생각을더듣고싶어요')) }}
          </div>
        </div>
      </div>
    </li>
    <!-- 07 cheerup -->
    <li class="list-item">
      <div class="item cheerup" :class="{ checked: checkedItems[7] }" data-id="7" @click="toggleCampaignItemCheck(7)">
        <div class="item-icon">
          <div class="check-badge" />
        </div>
        <div class="text">
          <div class="info">
            <span class="theme color">{{ $t('응원') }}</span>
            <span class="desc" v-html="removeTag($t('진심어린지지와응원을보내주세요'))" />
          </div>
          <div class="title">
            {{ removeTag($t('기도응원할게요잘될거예요')) }}
          </div>
        </div>
      </div>
    </li>
    <!-- 08 consideration -->
    <li class="list-item">
      <div
        class="item consideration"
        :class="{ checked: checkedItems[8] }"
        data-id="8"
        @click="toggleCampaignItemCheck(8)"
      >
        <div class="item-icon">
          <div class="check-badge" />
        </div>
        <div class="text">
          <div class="info">
            <span class="theme color">{{ $t('배려') }}</span>
            <span class="desc" v-html="removeTag($t('주변을살피는관심에서배려가시작됩니다'))" />
          </div>
          <div class="title">
            {{ removeTag($t('제가도울일은없나요')) }}
          </div>
        </div>
      </div>
    </li>

    <!-- 09 compliment -->
    <li class="list-item">
      <div
        class="item compliment"
        :class="{ checked: checkedItems[9] }"
        data-id="9"
        @click="toggleCampaignItemCheck(9)"
      >
        <div class="item-icon">
          <div class="check-badge" />
        </div>
        <div class="text">
          <div class="info">
            <span class="theme color">{{ $t('칭찬') }}</span>
            <span class="desc" v-html="removeTag($t('따뜻한칭찬은서로에게행복을가져다줍니다'))" />
          </div>
          <div class="title">
            {{ removeTag($t('대단해요잘하고있어요')) }}
          </div>
        </div>
      </div>
    </li>
  </ul>
</template>

<script lang="ts" setup>
const props = defineProps<{
  checkedItems?: Record<number, boolean>
  date: Date
}>()

const emits = defineEmits<{
  (event: 'onItemClick', campaignItemId: number, date: Date): void
}>()

const { $t } = useNuxtApp()

const checkedItems = computed(() => {
  return props.checkedItems ?? {}
})

async function toggleCampaignItemCheck(id: number) {
  emits('onItemClick', id, props.date)
}
</script>
